import { RegistrationQuestion } from '@/types/registration.types';
import { Get } from '../helpers';

export const FetchRegistrationQuestions = async (channel: number): Promise<RegistrationQuestion[]> => {
  return Get({ path: `/v3/admin/events/registration-questions/${channel}` });
};
